export default "__VITE_ASSET__bdb1e844__"